module.exports = __webpack_public_path__ + "static/img/right-btn-active.a6a07d17.png";